module.exports = __webpack_public_path__ + "static/img/son6_active.2d4dde9f.jpg";